import {h} from 'preact';

export default function FileInputBusiness({title, countFiles, onChangeFile, fileList, renderInput, errors}){
	if (!renderInput) return '';
	return (
		<div className="form__item">
			<div className={`file-input ${errors ? 'form-field_state_error':''}`}>
				<div className="file-input__title">
					{title}
				</div>
				<label className="file-input__body">
					<input className="file-input__input" multiple={true} type="file" onChange={onChangeFile} value=''/>
					<span className="file-input__button button-primary button-primary_pdv_lg">
						<span>{countFiles ? 'Добавить':'Выбрать'}</span>
					</span>
					<span className="file-input__file-name">
						<span className="file-input__text">
							{
								countFiles
									? `Файлов выбрано: ${countFiles}`
									:'Файлы не выбраны'
							}
						</span>
					</span>
				</label>
				{
					!countFiles ||
					<ul className="file-input__files-list">
						{
							fileList
						}
					</ul>
				}
			</div>
		</div>
	)
}